import { Component } from '@angular/core';
import {SidebarMenuComponent} from "../../shared/components/sidebar-menu/sidebar-menu.component";
import {RouterOutlet} from "@angular/router";

@Component({
    selector: 'app-main',
    imports: [
        SidebarMenuComponent,
        RouterOutlet
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent {

}
